const Data = [
  {
    dataId: '1',
    name: "ERDData",
    pillars: [
      {
        id: 1,
        pillar: "Strategic Intent",
        percentage: 23,
        questions: [
          {
            questionNumber: 1,
            weight: 30,
            question: "What role does your center(s) play in defining global priorities for the HQ?", 
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 30,
            question: "What role does your center(s) play in defining local strategy and local priorities for the GCC?",
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "Which KPIs do you actively measure across capabilities within your center(s)?",
            options: [
              { option: "Delivery and Cost Metrics", optionNumber: 1, marks: 1 },
              { option: "Delivery and Cost Metrics + Talent Development and Management", optionNumber: 2, marks: 2.33 },
              { option: "Delivery and Cost Metrics + Customer Impact and Innovation Metrics", optionNumber: 3, marks: 3.67 },
              { option: "Delivery and Cost Metrics + Revenue and Profit Metrics", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 25,
            question: "What role does the center head/leadership play in defining and owning the budget for the center(s)?",
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 2,
        pillar: "Operating Model",
        percentage: 18,
        questions: [
          {
            questionNumber: 1,
            weight: 28,
            question: "Within the global reporting structure, please indicate the level at which the center head(s) is positioned",
            options: [
              { option: "CTO-4", optionNumber: 1, marks: 1 },
              { option: "CTO-3", optionNumber: 2, marks: 2.33 },
              { option: "CTO-2", optionNumber: 3, marks: 3.67 },
              { option: "CTO-1", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 14,
            question: "How frequently do communication and coordination meetings take place between the center(s) and HQ?",
            options: [
              { option: "Yearly, Formal", optionNumber: 1, marks: 1 },
              { option: "Half-Yearly, Informal", optionNumber: 2, marks: 2.33 },
              { option: "Half-Yearly, Formal", optionNumber: 3, marks: 3.67 },
              { option: "Quarterly, Formal", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 3,
            weight: 39,
            question: "What percentage of roles within the center(s) handle responsibilities and ownership on a global level?",
            options: [
              { option: "<10%", optionNumber: 1, marks: 1 },
              { option: "10-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-20%", optionNumber: 3, marks: 3.67 },
              { option: ">20%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 19,
            question: "Are dedicated Centers of Excellence (CoEs) present across technology and functional areas (such as AI/ML, Automation, etc.)? If yes, how many?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Yes, 1", optionNumber: 2, marks: 2.33 },
              { option: "Yes, 2 or more", optionNumber: 3, marks: 3.67 },
              { option: "Yes, five or more and across Functions", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 3,
        pillar: "Portfolio Ownership",
        percentage: 23,
        questions: [
          {
            questionNumber: 1,
            weight: 30,
            question: "What percentage of global products or portfolios are developed and owned by your center(s) in India?",
            options: [
              { option: "0-20%", optionNumber: 1, marks: 1 },
              { option: "20-40%", optionNumber: 2, marks: 2.33 },
              { option: "40-60%", optionNumber: 3, marks: 3.67 },
              { option: "60-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 30,
            question: "What level of ownership is driven by the center(s) across stages of the PDLC?",
            options: [
              { option: "20% Design, 40% Development, 40% Testing & Support", optionNumber: 3, marks: 3.67 },
              { option: "20% Design (Legacy), 40% Development, 30% Testing & Support, 10% Design (Poc, Concept, Growth Stage)", optionNumber: 4, marks: 5 },
              { option: "50% Development, 50% Testing & Support", optionNumber: 2, marks: 2.33 },
              { option: "100% Testing & Support", optionNumber: 1, marks: 1 },
            ],
            info: ""
          },
          { //this qsn is for it
            questionNumber: 3,
            weight: 25,
            question: "What percentage of portfolios managed from the center(s) are across the Run, Grow, and Transform stages?",
            options: [
              { option: "0-10%: Transform, 10-20%: Grow, >70%: Run", optionNumber: 1, marks: 1 },
              { option: "5-15%: Transform, 15-25%: Grow, 60-70%: Run", optionNumber: 2, marks: 2.33 },
              { option: "10-20%: Transform, 20-30%: Grow, 50-60%: Run", optionNumber: 3, marks: 3.67 },
              { option: "15-25%: Transform, 25-35%: Grow, 40-50%: Run", optionNumber: 4, marks: 5 }
            ],
            info: "Run: Involves maintaining current business capabilities, resolving customer issues and work on reducing costs and improving price-performance ratio, lessening risk and keeping the lights on for essential business processes. Roles are mainly operational.<br/><br/>Grow: Expanding current capabilities and focus on improving business processes to deliver differentiation and competitiveness. Roles are enhancing in nature.<br/><br/>Transform: Driving transformative business capabilities, to create new value proposition and enact new business models, across multiple areas of operations. Roles include Innovation aspects"
          },                 
          {
            questionNumber: 4,
            weight: 15,
            question: "Are dedicated Customer/End User Connect programs driven by the center(s)?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Access to Data or Conversations", optionNumber: 3, marks: 3.67 },
              { option: "Direct interactions including customer briefing center with no dependency on global", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 4,
        pillar: "People & Culture",
        percentage: 14,
        questions: [
          {
            questionNumber: 1,
            weight: 19,
            question: "What percentage of global ER&D talent is present in India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 15,
            question: "What percentage of Product managers globally are present in India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ]
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "What percentage of Architects globally are present in India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 12,
            question: "What percentage of talent within your center(s) is working across niche skill areas (AI, Automation, Robotics, IoT, Autonomous Driving, etc.)?",
            options: [
              { option: "<5%", optionNumber: 1, marks: 1 },
              { option: "5-10%", optionNumber: 2, marks: 2.33 },
              { option: "15-20%", optionNumber: 3, marks: 3.67 },
              { option: ">20%", optionNumber: 4, marks: 5 }
            ]
          },
          {
            questionNumber: 5,
            weight: 8,
            question: "Does the center(s) have a dedicated L&D budget? Is it locally or globally mandated?",
            options: [
              { option: "No", optionNumber: 1, marks: 1 },
              { option: "Yes, Locally Mandated", optionNumber: 2, marks: 2.33 },
              { option: "Yes, Globally Mandated", optionNumber: 3, marks: 3.67 }
            ],
            info: ""
          },
          {
            questionNumber: 6,
            weight: 9,
            question: "What channels/mechanisms do you use to acquire talent for your center(s)?",
            options: [
              { option: "T2,T3 College Recruitment, Adhoc Lateral Hiring", optionNumber: 1, marks: 1 },
              { option: "T1 College Recruitment, Referral Lateral Hiring", optionNumber: 2, marks: 2.33 },
              { option: "T1 College Recruitment + Internship, Referral Lateral Hiring, Headhunting", optionNumber: 3, marks: 3.67 },
              { option: "T1 College Recruitment + Research Partnership Based Hiring, Referral Lateral Hiring, Headhunting", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 7,
            weight: 6,
            question: "What channels/mechanisms do you use to brand in-house CoEs?",
            options: [
              { option: "Hiring Drives", optionNumber: 1, marks: 1 },
              { option: "Hiring Drives + Passive Ecosystem Collabs (Hackathons, Tech Meetups, Ted Talks, Etc)", optionNumber: 3, marks: 3.67 },
              { option: "Hiring Drives + Active Ecosystem Collab (Research Partnerships, Startup Acquisition/Incubation, Govt Partnerships, Etc.)", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 8,
            weight: 9,
            question: "Does the center(s) run internal and external branding programs? If yes, how frequently are these programs run and across which channels/mechanisms?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Ad-hoc & Informal – Conducted occasionally, mainly during induction, with no leadership follow-through or measurable impact", optionNumber: 2, marks: 2.33 },
              { option: "Adapted Global Program – A structured program based on global initiatives, frequently executed with regular check-ins", optionNumber: 3, marks: 3.67 },
              { option: "India-owned Program – Fully localized, outcome-driven, and independently managed with India-specific messaging", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 9,
            weight: 6,
            question: "How are DE&I programs structured?",
            options: [
              { option: "Fragmented: Not a priority; initiatives are ad-hoc, lack focus on diversity, and run in isolation without strategic goals", optionNumber: 1, marks: 1 },
              { option: "Equitable: Programs are put in place to eliminate bias from certain people processes with enablers being put in place as and when required", optionNumber: 2, marks: 2.33 },
              { option: "Cohesive: People processes have constant support from enablers that help the organization sustain, analyze and expand the diversity harbored within", optionNumber: 3, marks: 3.67 },
              { option: "Harmonized: Extensive work being done in collaboration with the external ecosystem helps organizations have a unified engagement platform for their people", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 5,
        pillar: "Process Enablement",
        percentage: 10,
        questions: [
          {
            questionNumber: 1,
            weight: 55,
            question: "What role does the center head/leadership play in the selection and onboarding of tools and platforms?",
            options: [
              { option: "Consulted: India may not have a role in the final decision-making process of tools and platforms but may offer inputs for the global team to make a decision", optionNumber: 2, marks: 2.33 },
              { option: "Informed: India team plays no role in the process for selection and onboarding for tools and platforms adopted by the organization.", optionNumber: 1, marks: 1 },
              { option: "Responsible: India has complete autonomy to onboard tools specific to local needs but only play an influencer role in the decision-making for global tools", optionNumber: 3, marks: 3.67 },
              { option: "Accountable: The local team has complete authority to onboard and implement tools specific to local needs", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 45,
            question: "What percentage of processes within the center(s) are automated?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "<10% of process automated", optionNumber: 2, marks: 2.33 },
              { option: "At least 25% of processes automated", optionNumber: 3, marks: 3.67 },
              { option: ">50% of processes are automated", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 6,
        pillar: "Innovation & Collaboration",
        percentage: 12,
        questions: [
          {
            questionNumber: 1,
            weight: 35,
            question: "How much are innovation programs run by the center, aligned to the global innovation lifecycle?",
            options: [
              { option: "No Alignment – Programs are purely engagement activities with no tangible outcomes (ideas, concepts, etc.).", optionNumber: 1, marks: 1 },
              { option: "Low Alignment – Programs generate ideas but are ad-hoc, with no clear path for progression.", optionNumber: 2, marks: 2.33 },
              { option: "Moderate Alignment – Programs follow a structured flow, allowing ideas to progress through stages.", optionNumber: 3, marks: 3.67 },
              { option: "High Alignment – Programs are fully integrated into the innovation lifecycle, with a systematic approach to risk reduction.", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 25,
            question: "What share of global patents is held by GCCs?",
            options: [
              { option: "Very Low", optionNumber: 1, marks: 1 },
              { option: "Low", optionNumber: 2, marks: 2.33 },
              { option: "Average", optionNumber: 3, marks: 3.67 },
              { option: "High", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "What is the level of participation of teams across internal innovation programs run at the center(s)?",
            options: [
              { option: "Very Low Participation – Less than 10% of BUs participate, limited to the ideation stage.", optionNumber: 1, marks: 1 },
              { option: "Low Participation – 10% to 20% of BUs participate, but only at the ideation stage.", optionNumber: 2, marks: 2.33 },
              { option: "Average Participation – 20% to 40% of BUs participate, engaging in both ideation and problem-solution fit stages.", optionNumber: 3, marks: 3.67 },
              { option: "High Participation – More than 40% of BUs participate, contributing across ideation, problem-solution fit, and later stages.", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 25,
            question: "Does the center(s) engage in external collaborations for innovation? If yes, what tangible outcomes are realized through these collaborations?",
            options: [
              { option: "None or limited to superficial outcomes and short-term outcomes (event branding and sponsorship, etc.)", optionNumber: 1, marks: 1 },
              { option: "Nascent or early stages with no long-term commitment or funding in place. Very little tangible outcomes realized", optionNumber: 2, marks: 2.33 },
              { option: "Highly structured with a clear outcome. India may have discretionary budgets and the GCoE may already have successful outcomes as part of the development roadmap and/or equity and acqui-hiring", optionNumber: 3, marks: 3.67 },
              { option: "India runs and owns global collaboration programs. Scope of partnership is also global. Complete autonomy over budget with no intervention by global", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
    ]
  },
  {
    dataId: '2',
    name: "ITData",
    pillars: [
      {
        id: 1,
        pillar: "Strategic Intent",
        percentage: 23,
        questions: [
          {
            questionNumber: 1,
            weight: 30,
            question: "What role does your center(s) play in defining global priorities for the HQ?",
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 30,
            question: "What role does your center(s) play in defining local strategy and local priorities for the GCC?",
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ]
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "Which KPIs do you actively measure across capabilities within your center(s)?",
            options: [
              { option: "Delivery and Cost Metrics", optionNumber: 1, marks: 1 },
              { option: "Delivery and Cost Metrics + Talent Development and Management", optionNumber: 2, marks: 2.33 },
              { option: "Delivery and Cost Metrics + Customer Impact and Innovation Metrics", optionNumber: 3, marks: 3.67 },
              { option: "Delivery and Cost Metrics + Revenue and Profit Metrics", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 25,
            question: "What role does the center head/leadership play in defining and owning the budget for the center(s)?",
            options: [
              { option: "Informed", optionNumber: 1, marks: 1 },
              { option: "Consulted", optionNumber: 2, marks: 2.33 },
              { option: "Responsible", optionNumber: 3, marks: 3.67 },
              { option: "Accountable", optionNumber: 4, marks: 5 }
            ]
          }
        ]
      },
      {
        id: 2,
        pillar: "Operating Model",
        percentage: 18,
        questions: [
          {
            questionNumber: 1,
            weight: 28,
            question: "Within the global reporting structure, please indicate the level at which the center head(s) and functional head(s) are positioned",
            options: [
              { option: "CIO-4", optionNumber: 1, marks: 1 },
              { option: "CIO-3", optionNumber: 2, marks: 2.33 },
              { option: "CIO-2", optionNumber: 3, marks: 3.67 },
              { option: "CIO-1", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 14,
            question: "How frequently do you believe communication and coordination meetings take place between the center(s) and HQ?",
            options: [
              { option: "Yearly, Formal", optionNumber: 1, marks: 1 },
              { option: "Half-Yearly, Informal", optionNumber: 2, marks: 2.33 },
              { option: "Half-Yearly, Formal", optionNumber: 3, marks: 3.67 },
              { option: "Quarterly, Formal", optionNumber: 4, marks: 5 }
            ]
          },
          {
            questionNumber: 3,
            weight: 39,
            question: "What percentage of roles within the center(s) handle responsibilities and ownership on a global level?",
            options: [
              { option: "<10%", optionNumber: 1, marks: 1 },
              { option: "10-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-20%", optionNumber: 3, marks: 3.67 },
              { option: ">20%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 19,
            question: "Are dedicated Centers of Excellence (CoEs) present across technology and functional areas?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Nascent", optionNumber: 2, marks: 2.33 },
              { option: "1-2 Established CoEs", optionNumber: 3, marks: 3.67 },
              { option: "Multiple established CoEs across function", optionNumber: 4, marks: 5 }
            ]
          }
        ]
      },
      {
        id: 3,
        pillar: "Portfolio Ownership",
        percentage: 23,
        questions: [
          {
            questionNumber: 1,
            weight: 30,
            question: "What percentage of global products or portfolios are developed and owned by your center(s) in India?",
            options: [
              { option: "0-20%", optionNumber: 1, marks: 1 },
              { option: "20-40%", optionNumber: 2, marks: 2.33 },
              { option: "40-60%", optionNumber: 3, marks: 3.67 },
              { option: "60-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 30,
            question: "What level of ownership is driven by the center(s) across stages of the SDLC?",
            options: [
              { option: "40% Development, 40% Testing & Support, 20% Design", optionNumber: 3, marks: 3.67 },
              { option: "40% Development, 30% Testing & Support, 20% Design (Legacy), 10% Design (Poc, Concept, Growth Stage)", optionNumber: 4, marks: 5 },
              { option: "100% Testing & Support", optionNumber: 1, marks: 1 },
              { option: "50% Development, 50% Testing & Support", optionNumber: 2, marks: 2.33 }
            ]
          },
          {
            questionNumber: 3,
            weight: 25,
            question: "What percentage of portfolios managed from the center(s) are across the Run, Grow, and Transform stages?",
            options: [
              { option: "0-10%: Transform, 10-20%: Grow, >70%: Run", optionNumber: 1, marks: 1 },
              { option: "5-15%: Transform, 15-25%: Grow, 60-70%: Run", optionNumber: 2, marks: 2.33 },
              { option: "10-20%: Transform, 20-30%: Grow, 50-60%: Run", optionNumber: 3, marks: 3.67 },
              { option: "15-25%: Transform, 25-35%: Grow, 40-50%: Run", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 15,
            question: "Are dedicated Customer/End User Connect programs driven by the center(s)?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Access to Data or Conversations", optionNumber: 3, marks: 3.67 },
              { option: "Direct interactions including customer briefing center with no dependency on global", optionNumber: 4, marks: 5 }
            ],
            info: ""
          }
        ]
      },
      {
        id: 4,
        pillar: "People & Culture",
        percentage: 14,
        questions: [
          {
            questionNumber: 1,
            weight: 19,
            question: "What percentage of global IT talent is based out of India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 15,
            question: "What percentage of Program Managers/IT Business Analysts globally are present in India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ]
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "What percentage of Enterprise/Solution Architects globally are present in India?",
            options: [
              { option: "0-5%", optionNumber: 1, marks: 1 },
              { option: "5-15%", optionNumber: 2, marks: 2.33 },
              { option: "15-35%", optionNumber: 3, marks: 3.67 },
              { option: "35-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 12,
            question: "What percentage of talent within your center(s) is working across niche skill areas?",
            options: [
              { option: "<5%", optionNumber: 1, marks: 1 },
              { option: "5-10%", optionNumber: 2, marks: 2.33 },
              { option: "15-20%", optionNumber: 3, marks: 3.67 },
              { option: ">20%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 5,
            weight: 8,
            question: "Does the center(s) have a dedicated L&D budget? Is it locally or globally mandated?",
            options: [
              { option: "No", optionNumber: 1, marks: 1 },
              { option: "Yes, Locally Mandated", optionNumber: 2, marks: 2.33 },
              { option: "Yes, Globally Mandated",  optionNumber: 3, marks: 3.67 }
            ],
            info: ""
          },
          {
            questionNumber: 6,
            weight: 9,
            question: "What channels/mechanisms do you use to acquire talent for your center(s)?",
            options: [
              { option: "T2,T3 College Recruitment, Adhoc Lateral Hiring", optionNumber: 1, marks: 1 },
              { option: "T1 College Recruitment, Referral Lateral Hiring", optionNumber: 2, marks: 2.33 },
              { option: "T1 College Recruitment + Internship, Referral Lateral Hiring, Headhunting", optionNumber: 3, marks: 3.67 },
              { option: "T1 College Recruitment + Research Partnership Based Hiring, Referral Lateral Hiring, Headhunting", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 7,
            weight: 6,
            question: "What channels/mechanisms do you use to brand in-house CoEs?",
            options: [
              { option: "Hiring Drives", optionNumber: 1, marks: 1 },
              { option: "Hiring Drives + Passive Ecosystem Collabs (Hackathons, Tech Meetups, Ted Talks, Etc)", optionNumber: 3, marks: 3.67 },
              { option: "Hiring Drives + Active Ecosystem Collab (Research Partnerships, Startup Acquisition/Incubation, Govt Partnerships, Etc.)", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 8,
            weight: 9,
            question: "Does the center(s) run internal and external branding programs? If yes, how frequently are these programs run and across which channels/mechanisms?",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "Adhoc and informal. Typically done as a part of the induction program without follow through by the leadership or any tie-in with measurable metrics", optionNumber: 2, marks: 2.33 },
              { option: "Global program or existing program is extrapolated and adapted to India. More frequently done and structured with repeated check-ins", optionNumber: 3, marks: 3.67 },
              { option: "Strategically planned as part of the business strategy, and executed in a systematic and well-measured manner. Internal branding is continuous, with multiple initiatives driven across channels", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 9,
            weight: 6,
            question: "How are DE&I programs structured?",
            options: [
              { option: "Fragmented: Not looked at as priority. Approach to initiatives are ad hoc in nature with no focus on Diversity and programs are run in isolation with no strategic goals", optionNumber: 1, marks: 1 },
              { option: "Equitable: Programs are put in place to eliminate bias from certain people processes with enablers being put in place as and when required", optionNumber: 2, marks: 2.33 },
              { option: "Cohesive: People processes have constant support from enablers that help organization sustain, analyse and expand the diversity harboured within", optionNumber: 3, marks: 3.67 },
              { option: "Harmonized: Extensive work being done in collaboration with the external ecosystem helps organizations have a unified engagement platform for their people", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
        ]
      },
      {
        id: 5,
        pillar: "Process Enablement",
        percentage:10,
        questions: [
          {
            questionNumber: 1,
            weight: 34,
            question: "What role does the center head/leadership play in selection and onboarding of tools and platforms?",
            options: [
              { option: "Informed:India team plays no role in the process for selection and onboarding for tools and platforms adopted by the organization", optionNumber: 1, marks: 1 },
              { option: "Consulted:India may not have a role in final decision making process of tools and platforms but may offer suggested inputs for the global team to make a decision", optionNumber: 2, marks: 2.33 },
              { option: "Responsible:India has complete autonomy to onboard tools specific to local needs but only play an influencer role in the decision making for global tools", optionNumber: 3, marks: 3.67 },
              { option: "Accountable:The local team has complete authority to onboard and implement tools specific to local needs", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 33,
            question: "What percentage of processes within the center(s) are automated? (this includes process automation such as RPA, Workflow orchestration, etc.)",
            options: [
              { option: "None", optionNumber: 1, marks: 1 },
              { option: "<10% of process automated", optionNumber: 2, marks: 2.33 },
              { option: "Atleast 25% of processes automated", optionNumber: 3, marks: 3.67 },
              { option: ">50% of processes are automated", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 3,
            weight: 33,
            question: "What percentage of processes/frameworks within the center(s) are agile?",
            options: [
              { option: "<20%", optionNumber: 1, marks: 1 },
              { option: "20-40%", optionNumber: 2, marks: 2.33 },
              { option: "40-60%", optionNumber: 3, marks: 3.67 },
              { option: "60-100%", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
        ]
      },
      {
        id: 6,
        pillar: "Innovation & Collaboration",
        percentage: 12,
        questions: [
          {
            questionNumber: 1,
            weight: 35,
            question: "How much are innovation programs run by the center, aligned to the global innovation lifecycle?",
            options: [
              { option: "No Alignment – Programs are purely engagement activities with no tangible outcomes (ideas, concepts, etc.).", optionNumber: 1, marks: 1 },
              { option: "Low Alignment – Programs generate ideas but are ad-hoc, with no clear path for progression.", optionNumber: 2, marks: 2.33 },
              { option: "Moderate Alignment – Programs follow a structured flow, allowing ideas to progress through stages.", optionNumber: 3, marks: 3.67 },
              { option: "High Alignment – Programs are fully integrated into the innovation lifecycle, with a systematic approach to risk reduction.", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 2,
            weight: 25,
            question: "What share of global patents is held by GCCs?",
            options: [
              { option: "Very Low", optionNumber: 1, marks: 1 },
              { option: "Low", optionNumber: 2, marks: 2.33 },
              { option: "Average", optionNumber: 3, marks: 3.67 },
              { option: "High", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 3,
            weight: 15,
            question: "What is the level of participation of teams across internal innovation programs run at the center(s)?",
            options: [
              { option: "Very low participation (< 10% participation, 1/2 Bus and only at ideation stage)", optionNumber: 1, marks: 1 },
              { option: "Low participation (10% to 20%, 2/3 Bus, at only ideation stage)", optionNumber: 2, marks: 2.33 },
              { option: "Average Participation (20% to 40%, 2/3 Bus at ideation and problem-solution fit stages)", optionNumber: 3, marks: 3.67 },
              { option: "High Participation (>40%, all Bus at ideation, problem-solution fit and beyond stages)", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
          {
            questionNumber: 4,
            weight: 25,
            question: "Does the center(s) engage in external collaborations for innovation? If yes, what tangible outcomes are realised through these collaborations?",
            options: [
              { option: "None or limited to superficial outcomes and short term outcomes (event branding and sponsorship etc)", optionNumber: 1, marks: 1 },
              { option: "Nascent or early stages with no long term outcomes defined. GCC does not have budgets or autonomy to define outcomes from the collaboration", optionNumber: 2, marks: 2.33 },
              { option: "Highly structured with a clear outcome. India may have discretionary budgets and the GCC may already have successful outcomes as part of the development roadmap and/or equity and acqui-hiring", optionNumber: 3, marks: 3.67 },
              { option: "India runs and owns global collaboration programs. Scope of partnership is also global. Complete autonomy over budget with no intervention by global", optionNumber: 4, marks: 5 }
            ],
            info: ""
          },
        ]
      },
    ]
  },
];

export default Data;